import classNames from 'classnames';
import * as React from 'react';

import css from './BooksFormErrorMessage.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const BooksFormErrorMessage = ({ className, children }: Props) => {
  const classes = classNames(css.BooksFormErrorMessage, className);

  return <div className={classes}>{children}</div>;
};

export default BooksFormErrorMessage;
